function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Broadband = function Broadband(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M7.837 10.998a1 1 0 0 1 1 1l-.001.933h12.247c1.103 0 2 .897 2 2v5.662c0 1.103-.897 2-2 2H3.013c-1.103 0-2-.897-2-2v-5.662c0-1.103.897-2 2-2h3.823v-.933a1 1 0 0 1 1-1m13.246 3.933H3.013v5.662h18.07zm-6.518 1.603a1.25 1.25 0 1 1-.001 2.501 1.25 1.25 0 0 1 0-2.5m3.583 0a1.25 1.25 0 1 1 0 2.501 1.25 1.25 0 0 1 0-2.5M7.836 7.868c1.228 0 2.391.537 3.19 1.471a1 1 0 0 1-1.52 1.3c-.827-.967-2.466-.982-3.309-.034a.999.999 0 1 1-1.495-1.328 4.2 4.2 0 0 1 3.134-1.409m0-2.933c1.81 0 3.538.68 4.863 1.92a1 1 0 1 1-1.366 1.46 5.119 5.119 0 0 0-6.952-.038A.998.998 0 1 1 3.033 6.8a7.1 7.1 0 0 1 4.804-1.866M7.838 2c2.397 0 4.722.86 6.544 2.425a.999.999 0 1 1-1.301 1.518A8.06 8.06 0 0 0 7.837 4a8.07 8.07 0 0 0-5.192 1.899 1 1 0 0 1-1.29-1.528A10.06 10.06 0 0 1 7.837 2"
  }));
};
export default Broadband;